import {
  OrderTable,
  OrderTableFilters,
  useDefaultVbsOrderListRequest,
} from "@/services/backend/vbs/orders/components/order-table";
import { NavLink, useNavigate, useParams } from "react-router";
import { ReactNode, useCallback, useState } from "react";
import {
  MilestonePage,
  MilestonePageContent,
  MilestonePageHeader,
  MilestonePageTitle,
} from "@/shared/bsm/core/milestone/components/ui/milestone-page";
import t from "@/lang/lang";
import { CreateOrderButton } from "@/services/backend/vbs/orders/components/create-order-button";

export function OrdersIndexRoute() {
  const { processId } = useParams();
  const navigate = useNavigate();
  const [request, setRequest] = useState(
    useDefaultVbsOrderListRequest(processId!),
  );

  const renderRowLink = useCallback(
    (id: string, children: ReactNode) => <NavLink to={id}>{children}</NavLink>,
    [],
  );

  return (
    <MilestonePage>
      <MilestonePageHeader>
        <MilestonePageTitle>{t("Auftragseingänge")}</MilestonePageTitle>
      </MilestonePageHeader>
      <MilestonePageContent>
        <div className="grid gap-2">
          <div className="flex justify-between">
            <OrderTableFilters request={request} onRequestChange={setRequest} />
            <CreateOrderButton
              processId={processId!}
              onCreated={(id) => navigate(id)}
            />
          </div>
          <OrderTable
            request={request}
            onRequestChange={setRequest}
            renderRowLink={renderRowLink}
          />
        </div>
      </MilestonePageContent>
    </MilestonePage>
  );
}
